import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Signup } from "../../../Controllers/Auth";
import toast from "react-hot-toast";
import Authorization from "../../../Main/authorization";
import Form from "../../../Componets/Form";
import forms from "../../../Data/Forms/Signup/forms";
import { Button } from "antd";

const SignupForm = () => {
  let navigate = useNavigate();

  let isAuthenticate = Authorization();

  const [values, setValues] = useState(forms);

  const formdata = async (data) => {
    if (data?.status) {
      const signup = await Signup(data?.data);

      if (signup?.status) {
        toast?.success(signup?.message);
        navigate("/signin");
      } else {
        toast?.error(signup?.message);
      }
    }
  };

  const fetchData = async () => {
    values[0].button = (
      <div>
        <Button
          size="large"
          className="bg-[#0dacce] text-medium form-add-button w-full"
          type="primary"
          htmlType="submit"
        >
          Create account
        </Button>
        <div className="pt-3 text-medium text-gray-500 text-center">
          <span>Already have an account?</span>
          &nbsp;
          <button type="button" onClick={() => navigate("/signin")}>
            <u className="text-[#0dacce]">Signin</u>
          </button>
        </div>
      </div>
    );

    setValues([...values]);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="bg-gray-100">
      <Form form={values} setForm={setValues} formdata={formdata} />
    </div>
  );
};

export default SignupForm;
